import { Card, Box, Typography, useTheme } from "@mui/material";

const ClientsSitesCard = ({ client1Sites, client2Sites, subtitle1 = "", subtitle2 = "", size = 100 }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        width: size + 92,
        height: 218,
        p: "19px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        borderRadius: 2,
        justifyContent: "center",
        gap: 1.5
      }}
    >
      <Typography
        variant="title"
        sx={{
          gridArea: "title",
          textAlign: "center",
          fontSize: { xs: "0.7rem", sm: "0.8rem", md: "1.0rem" },
          mb:"8px",
          mt:"3px",
        }}
      >
        📊​ Répartition des sites (PRD)
      </Typography>

      <Box sx={{
        display: "flex",
        gap: 1,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.04)' : theme.palette.background.paper,
        borderRadius: 1,
        py: 0.5,
        px: 1
      }}>
        <Box sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: "#4caf50",
          flexShrink: 0
        }} />
        {subtitle1 && <Typography variant="subtitle2" sx={{ marginRight: "auto" }}>{subtitle1}</Typography>}
        <Typography variant="h4" sx={{ m: 0, lineHeight: 1.6}}>
          {client1Sites}
        </Typography>
      </Box>

      <Box sx={{
        display: "flex",
        gap: 1,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.04)' : theme.palette.background.paper,
        borderRadius: 1,
        py: 0.5,
        px: 1
      }}>
        <Box sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: "#ff9800",
          flexShrink: 0
        }} />
        {subtitle2 && <Typography variant="subtitle2" sx={{ marginRight: "auto" }}>{subtitle2}</Typography>}
        <Typography variant="h4" sx={{ m: 0, lineHeight: 1.6 }}>
          {client2Sites}
        </Typography>
      </Box>
    </Card>
  );
};

export default ClientsSitesCard;
